import { useContext } from "react";

import { ArrowUpRightIcon } from "@heroicons/react/24/outline";
import { Button, Skeleton } from "@upstageai/ui";
import { Link } from "react-router-dom";

import { AWS } from "../../components/Icon/generated/AWS";
import { useDevice } from "../../hooks/useDevice";
import { ValidatorFileContext } from "../../hooks/useFile";
import { endpointStore } from "../../utils/mobx/EndpointStore";
import { envVarStore } from "../../utils/mobx/EnvVarStore";
import { cn } from "../../utils/style";

const AWSMarketplaceButtonSkeleton = () => {
  return <Skeleton className={cn("size-9 rounded-lg")} />;
};

export const AWSMarketplaceButton = () => {
  const { inferenceState } = useContext(ValidatorFileContext);
  const { showAWSMarketplace } = envVarStore;
  const { endpointType } = endpointStore;
  const { isMobile } = useDevice();

  let awsUrl = "";
  if (endpointType === "layout-analysis") {
    awsUrl = "https://aws.amazon.com/marketplace/pp/prodview-lv5bnpdco7xoq";
  } else if (endpointType === "ocr") {
    awsUrl = "https://aws.amazon.com/marketplace/pp/prodview-anvrh24vv3yiw";
  }

  if (!awsUrl || showAWSMarketplace !== "true") return null;

  if (inferenceState.isInfering) return <AWSMarketplaceButtonSkeleton />;

  return (
    <Link to={awsUrl} target="_blank">
      <Button
        variant="default"
        size={isMobile ? "icon" : "default"}
        className="gap-1.5 mobile:flex-row-reverse"
      >
        {isMobile && <AWS />}
        {!isMobile && (
          <>
            <span>Go to AWS</span>
            <ArrowUpRightIcon className="h-4 w-4" />
          </>
        )}
      </Button>
    </Link>
  );
};
